import {
  Box,
  CircularProgress,
  circularProgressClasses,
  Typography,
  Theme,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ChargingProgressProps } from './types';

export const ChargingProgress: React.FC<ChargingProgressProps> = ({
  value,
  size,
  differentText,
}) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <Box sx={{ position: 'relative', height: `${size}px` }}>
        <CircularProgress
          variant="determinate"
          size={size}
          sx={(theme: Theme) => ({
            color: theme.palette.gray[200],
            ...theme.applyStyles('dark', {
              color: theme.palette.gray[200],
            }),
          })}
          value={100}
        />
        <CircularProgress
          variant="determinate"
          sx={(theme: Theme) => ({
            color: theme.palette.green.main,
            position: 'absolute',
            left: 0,
            [`& .${circularProgressClasses.circle}`]: {
              strokeLinecap: 'round',
            },
            ...theme.applyStyles('dark', {
              color: theme.palette.green.main,
            }),
          })}
          value={value}
          size={size}
        />
      </Box>
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography variant="body1" textAlign="center" color="common.white">
          {size !== 50 ? (
            <>
              {t('orderPage.charged')}
              <Box component="span" display="block" />
            </>
          ) : null}
          {`${Math.round(differentText || value)}%`}
        </Typography>
      </Box>
    </Box>
  );
};
